import * as _ from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  students: [],
  loading: false,
  error: null,
  siteId: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PROHIBITED_ITEMS_REPORT_GRID_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.PROHIBITED_ITEMS_REPORT_GET_STUDENTS: {
      const { data, siteId } = action.payload;

      return {
        ...state,
        siteId,
        students: data.map(student => ({
          ...student,
          Checked: false,
        })),
      };
    }

    case types.PROHIBITED_ITEMS_REPORT_TOGGLE_CHECK_ALL: {
      const displayedStudentIdSeeds = action.payload.map(
        s => s._original.IdSeed
      );
      const students = _.cloneDeep(state.students);
      const updating = students.filter(s =>
        displayedStudentIdSeeds.includes(s.IdSeed)
      );
      const checked = action.payload.every(s => s._original.Checked);

      updating.forEach(s => (s.Checked = !checked));

      return {
        ...state,
        students,
      };
    }

    case types.PROHIBITED_ITEMS_REPORT_TOGGLE_STUDENT_CHECKED: {
      const students = _.cloneDeep(state.students);
      const match = students.find(s => s.IdSeed === action.payload);

      if (match) {
        match.Checked = !match.Checked;
      }

      return {
        ...state,
        students,
      };
    }

    case types.PROHIBITED_ITEMS_REPORT_GRID_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/page/reducer.js